import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import BannerSection from "@/components/BannerSection";
import Services from "@/components/Services";
import Pricing from "@/components/Pricing";
import TermsSection from "@/components/TermsSection";
import MemberSection from "@/components/MemberSection";
import TestimonialSection from "@/components/TestimonialSection";
import PickupForm from "@/components/PickupForm";
import Footer from "@/components/Footer";

export default function Home() {
    return (
        <div className="min-h-screen bg-white" data-testid="home-page">
            <Navbar />
            <main>
                <Hero />
                <Marquee />
                <BannerSection />
                <Services />
                <Pricing />
                <TermsSection />
                <MemberSection />
                <TestimonialSection />
                <PickupForm />
            </main>
            <Footer />
        </div>
    );
}
